import { render, staticRenderFns } from "./verAfiliado.vue?vue&type=template&id=0162405e&scoped=true"
import script from "./verAfiliado.vue?vue&type=script&lang=js"
export * from "./verAfiliado.vue?vue&type=script&lang=js"
import style0 from "./verAfiliado.vue?vue&type=style&index=0&id=0162405e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0162405e",
  null
  
)

export default component.exports